import { Pipe, PipeTransform } from '@angular/core';

import { AmountUtils } from '@rp/utils';

@Pipe({
  standalone: true,
  name: 'centsToDollarsPipe',
})
export class CentsToDollarsPipe implements PipeTransform {
  transform(value: number, currencyCode = 'USD'): string {
    const options: Intl.NumberFormatOptions = {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    };

    return new Intl.NumberFormat('en-US', options)
      .format(AmountUtils.centsToAmount(value))
      .replace('$', '$ ');
  }
}
